module.exports = __webpack_public_path__ + "img/oleksandr-zvozdin.93abefd9.jpg";